import { useEffect } from "react";
import axios from "axios";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { Gallery } from "@/components/landing/Gallery";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Pricing } from "@/components/landing/Pricing";
import { About } from "@/components/landing/About";
import { Verse } from "@/components/landing/Verse";
import { Faq } from "@/components/landing/Faq";
import { Testimonials } from "@/components/landing/Testimonials";
import { Reserve } from "@/components/landing/Reserve";
import { Footer } from "@/components/landing/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing() {
  useEffect(() => {
    const isManager = localStorage.getItem("wf_token") || localStorage.getItem("wf_manager");
    if (!isManager && !sessionStorage.getItem("wf_view_counted")) {
      sessionStorage.setItem("wf_view_counted", "1");
      axios.post(`${API}/track/view`).catch(() => {});
    }
  }, []);

  return (
    <main data-testid="landing-page">
      <Nav />
      <Hero />
      <Manifesto />
      <Gallery />
      <HowItWorks />
      <Pricing />
      <About />
      <Verse />
      <Faq />
      <Testimonials />
      <Marquee />
      <Reserve />
      <Footer />
    </main>
  );
}
